import parsePhoneNumber from 'libphonenumber-js';
import validator from 'validator';

import Logger from 'utils/Logger';

export const getParsedPhoneNumber = (phoneNumber: string) => {
  if (typeof phoneNumber !== 'string') {
    Logger.error('phoneNumber is not a string', phoneNumber);
    return null;
  }

  if (!phoneNumber) {
    return null;
  }

  if (!validator.isMobilePhone(phoneNumber)) {
    return null;
  }

  // Set default country code if not provided
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'CA');

  if (!parsedPhoneNumber) {
    return null;
  }

  return parsedPhoneNumber;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const parsedPhoneNumber = getParsedPhoneNumber(phoneNumber);

  if (!parsedPhoneNumber) {
    return phoneNumber;
  }

  return parsedPhoneNumber.formatNational();
};

export const formatPhoneNumberForApi = (phoneNumber: string) => {
  const parsedPhoneNumber = getParsedPhoneNumber(phoneNumber);

  if (!parsedPhoneNumber) {
    return null;
  }

  // API expects phone number in E.164 format
  return parsedPhoneNumber.number;
};
